import EditorVM from './editor-vm';
export default {
  init : function() {
    console.log('Kadenze.InstructorCourseEditor initialization function called');

    var $el = $('#course_edit_form');
    var data = $('#course_json').val();

    //Following options explained here: https://github.com/Knockout-Contrib/Knockout-Validation/wiki/Configuration
    var validationOptions = {
      insertMessages: true,
      errorsAsTitle: true,
      decorateInputElement: true,
      parseInputAttributes: true,
      messagesOnModified: true,
      errorElementClass: 'error',
      errorMessageClass: 'error',
      decorateElementOnModified: true,
      decorateElement: true
    };
    ko.applyBindingsWithValidation(new EditorVM(data), $el[0], validationOptions);
  }
};

